import { Unit } from '@data/unit/Unit';

export function isUnitMinimal(u: unknown): u is UnitMinimal {
	return !!(u && typeof u === 'object' && 'id' in u && 'name' in u);
}

type UnitMinimal = Partial<Pick<Unit, 'openTimeConfig' | 'hospitalTimeZone'>> & Pick<Unit, 'id' | 'name' | 'hospitalName' | 'hospital'>;

export default UnitMinimal;
